/*
  This component specifies options for a ResponsiveAuthor
  that is rendered in a similar authors context.

  The author's best_book and description are included.

  Components Organization Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import { PropTypes } from "react";
import GrPropTypes from "../shared/gr_prop_types";
import ResponsiveAuthor from "./responsive_author";

const SimilarAuthor = ({ author }) => (
  <ResponsiveAuthor author={author}
                    includeBestBook={true}
                    includeDescription={true} />
);

SimilarAuthor.propTypes = {
  author: GrPropTypes.author({
    bestBook: GrPropTypes.book().isRequired,
    followersCount: PropTypes.number.isRequired,
    worksCount: PropTypes.number.isRequired,
  }).isRequired,
};

export default SimilarAuthor;
